/**
 * Lux Footer — accordion breakpoint sync.
 * Menu columns are <details>: collapsed on mobile (user-toggleable),
 * forced open on desktop where they render as static columns.
 * A closed <details> hides content regardless of CSS, hence this sync.
 */
(function () {
  'use strict';

  var mq = window.matchMedia('(min-width: 750px)');

  function sync(scope) {
    (scope || document)
      .querySelectorAll('[data-footer-accordion]')
      .forEach(function (details) {
        if (mq.matches) {
          details.open = true;
        } else if (!details.dataset.userToggled) {
          details.open = false;
        }
      });
  }

  // Respect the user's manual toggles on mobile across resizes
  document.addEventListener('toggle', function (event) {
    var d = event.target;
    if (d.matches && d.matches('[data-footer-accordion]') && !mq.matches) {
      d.dataset.userToggled = 'true';
    }
  }, true);

  if (mq.addEventListener) {
    mq.addEventListener('change', function () { sync(); });
  } else if (mq.addListener) {
    mq.addListener(function () { sync(); });
  }

  document.addEventListener('shopify:section:load', function (event) {
    sync(event.target);
  });

  sync();
})();